<template>
    <section class="g-container || o-band">
        <div class="o-container">

            <app-intro class="u-d-flex align-items-center justify-content-between">
                <h3 class="u-mb-0">Abonnementsvoorwaarden</h3>

                <router-link to="/admin/subscriptions" class="c-link">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18.589" height="12.388" viewBox="0 0 18.589 12.388">
                        <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="2">
                            <path d="M17.589 6.223H4.714"/>
                            <path d="M7.439 10.989L1.001 6.195l6.438-4.8" stroke-linejoin="round"/>
                            <path d="M7.439 10.99L5.894 6.195l1.545-4.8" stroke-linejoin="round"/>
                        </g>
                    </svg>

                    Terug <span class="u-hidden-xsl-down">naar overzicht</span>
                </router-link>
            </app-intro>

            <transition-group name="fade" tag="section">
                <div key="content">

                    <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ad, blanditiis culpa ipsam maxime minima, minus non, omnis quam quia recusandae repudiandae voluptatum. Doloribus error fugiat inventore nulla provident. Est, hic.</p>

                    <p><span>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Animi consequatur doloribus inventore itaque laboriosam nesciunt, praesentium voluptatem. Alias asperiores dicta eos error impedit inventore modi neque officiis, quidem, ut vero.</span><span>Accusantium consectetur doloremque dolores doloribus dolorum earum exercitationem explicabo, fugit illum in inventore libero, natus odio odit rerum tenetur totam ut veniam? Ea mollitia omnis possimus quod rerum temporibus totam?</span></p>

                </div>
            </transition-group>

        </div>
    </section>
</template>

<script>
    import AppIntro from '../../components/app/AppIntro.vue';

    export default {
        components: {
            AppIntro,
        },
        data () {
            return {

            };
        },

    };
</script>

<style lang="scss" scoped>
    @import "../../assets/scss/_essentials.scss";

</style>
